import { getDefaultColorTheme } from "./color-themes/default-color-theme";
import { getAmethystPurpleColorTheme } from "./color-themes/amethyst-purple-color-theme";
import { getBurgundyColorTheme } from "./color-themes/burgundy-color-theme";
import { getDarkTealColorTheme } from "./color-themes/dark-teal-color-theme";
import { getLightBlueColorTheme } from "./color-themes/light-blue-color-theme";
import { getOrangeColorTheme } from "./color-themes/orange-color-theme";
import { getDarkGreenColorTheme } from "./color-themes/dark-green-color-theme";
import { getGoldenYellowColorTheme } from "./color-themes/golden-yellow-color-theme";
import { getTealColorTheme } from "./color-themes/teal-color-theme";
import { getBlueColorTheme } from "./color-themes/blue-color-theme";
import { getIndigoBlueColorTheme } from "./color-themes/indigo-blue-color-theme";
import { getLightBeigeColorTheme } from "./color-themes/light-beige-color-theme";
import { getCoralRedColorTheme } from "./color-themes/coral-red-color-theme";
import { getGrayDefaultColorTheme } from "./color-themes/gray-default-color-theme";

export const themes = {
	"default": getDefaultColorTheme,
	"light_blue": getLightBlueColorTheme,
	"orange": getOrangeColorTheme,
	"amethyst_purple": getAmethystPurpleColorTheme,
	"burgundy": getBurgundyColorTheme,
	"dark_teal": getDarkTealColorTheme,
	"dark_green": getDarkGreenColorTheme,
	"golden_yellow": getGoldenYellowColorTheme,

	// New color themes.
	"gray_default": getGrayDefaultColorTheme,
	"indigo_blue": getIndigoBlueColorTheme,
	"light_beige": getLightBeigeColorTheme,
	"teal": getTealColorTheme,
	"blue": getBlueColorTheme,
	"coral_red": getCoralRedColorTheme,
};

export const defaultThemeName = Object.keys(themes)[0] as ColorThemeId;

export type ColorThemeId = keyof typeof themes;